import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AuthService, GenesisUnitOfWork, AppInformationService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import _ from 'lodash';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-parts-order-overview',
    templateUrl: './parts-order-overview.component.html',
    styleUrls: ['./parts-order-overview.component.scss'],
    standalone: false
})
export class PartsOrderOverviewComponent implements OnInit {
    parts: any;
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private router: Router, public auth: AuthService, private modalService: BsModalService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        // await this.getData();
        this.parts = [];
        this.filter = {};
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.parts = await this.uow.getPartsPerOrderOverview(this.filter.orderNumber);
        this.appInfo.pleaseWaitHide();
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
    clear() {
        this.filter = {};
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
            // {
            //     widget: 'dxButton',
            //     options: {
            //         icon: 'refresh',
            //         elementAttr: { title: 'Reset Grid Layout' },
            //         onClick: () => {
            //             e.component.state({});
            //         },
            //     },
            //     location: 'after',
            // }
        );
    }

    async open(orderId: number) {
        const modalRef = this.modalService.show(OrderDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                orderId: orderId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                // this.appInfo.pleaseWaitShow();
                // await this.getData();
                // this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
            this.uow.rollback();
        });
    }
}
